export function preventVerificationOverscroll() {
  let previousTouch = null;

  const start = (event) => {
    previousTouch = event.touches.length === 1
      ? { x: event.touches[0].clientX, y: event.touches[0].clientY }
      : null;
  };
  const move = (event) => {
    if (event.touches.length !== 1 || !previousTouch) return;
    const touch = event.touches[0];
    const deltaY = touch.clientY - previousTouch.y;
    const deltaX = touch.clientX - previousTouch.x;
    previousTouch = { x: touch.clientX, y: touch.clientY };

    // Preserve desktop behavior, horizontal gestures, and native pinch zoom.
    if (window.innerWidth > 991 ||
        Math.abs((window.visualViewport?.scale ?? 1) - 1) >= 0.01 ||
        Math.abs(deltaY) <= Math.abs(deltaX)) return;

    let element = event.target instanceof Element ? event.target : event.target.parentElement;
    while (element && element !== document.body && element !== document.documentElement) {
      const overflow = window.getComputedStyle(element).overflowY;
      const scrollRange = element.scrollHeight - element.clientHeight;
      if (/^(auto|scroll)$/.test(overflow) && scrollRange > 1) {
        const canScroll = deltaY < 0
          ? element.scrollTop < scrollRange - 1
          : element.scrollTop > 1;
        if (canScroll) {
          const nextScrollTop = element.scrollTop - deltaY;
          if (nextScrollTop >= 0 && nextScrollTop <= scrollRange) return;
          // A single swipe can cross the boundary before the next touch event.
          element.scrollTop = Math.max(0, Math.min(scrollRange, nextScrollTop));
        }
        // Stop at the nearest scroll container; do not chain its edge drag.
        break;
      }
      element = element.parentElement;
    }
    if (event.cancelable) event.preventDefault();
  };
  const end = () => { previousTouch = null; };

  document.addEventListener('touchstart', start, { passive: true, capture: true });
  document.addEventListener('touchmove', move, { passive: false, capture: true });
  document.addEventListener('touchend', end, true);
  document.addEventListener('touchcancel', end, true);
  return () => {
    document.removeEventListener('touchstart', start, true);
    document.removeEventListener('touchmove', move, true);
    document.removeEventListener('touchend', end, true);
    document.removeEventListener('touchcancel', end, true);
  };
}
